// extracted by mini-css-extract-plugin
module.exports = {"title":"Activity_title__RF0ie","btn":"Activity_btn__KgCvt"};